
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DocumentInjectedContentType, DocumentInjectedEvidence } from "../../../../../../../domain/document";
import { DateFormatter } from "../../../../../../../domain/system";

@Component
export default class InjectedObjectEvidencePresentableMixin extends Mixins() {
  @Prop()
  source: DocumentInjectedEvidence;

  get type(): DocumentInjectedContentType {
    return this.source.type;
  }

  get supplement(): string {
    return [
      this.description,
      this.name,
      this.createdAt ? "記載日:" + this.createdAt : "",
      this.writtenBy ? "記載者:" + this.writtenBy : "",
      this.department,
    ].filter(s => !!s).join(" ");
  }

  get description(): string {
    return this.source.description ? this.source.description : "";
  }

  get name(): string {
    return this.source.name ? this.source.name : "";
  }

  get createdAt(): string {
    return DateFormatter.format(this.source.createdAt, "YYYY/MM/DD");
  }

  get writtenBy(): string {
    return this.authorName
      ? this.authorName + (this.authorRole ? "(" + this.authorRole + ")" : "")
      : "";
  }

  get authorName(): string | undefined {
    return this.source.writtenBy && this.source.writtenBy.name ? this.source.writtenBy.name : undefined;
  }

  get authorRole(): string | undefined {
    return this.source.writtenBy && this.source.writtenBy.role ? this.source.writtenBy.role : undefined;
  }

  get department(): string {
    return this.source.department ? this.source.department : "";
  }
}
